import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, Routes } from '@angular/router';
import type { AppEnvironment } from './environment/app-environment';
import { ENVIRONMENT } from './environment/environment.token';
import { authBearerInterceptor } from './auth/auth.interceptor';

export interface ProvideAppPlatformOptions {
  environment: AppEnvironment;
  routes: Routes;
}

/**
 * Providers do host: ambiente, HTTP com interceptor, router.
 */
export function provideAppPlatform(options: ProvideAppPlatformOptions): NonNullable<ApplicationConfig['providers']> {
  return [
    provideBrowserGlobalErrorListeners(),
    { provide: ENVIRONMENT, useValue: options.environment },
    provideHttpClient(withInterceptors([authBearerInterceptor])),
    provideRouter(options.routes),
  ];
}
